/* ─── State ─────────── */
const S = { goal:null, answers:{}, variants:{}, cartQty:{}, lead:null };
const TOTAL = 8;

/* ─── Products ─────────── */
const PRODS = {
  biostack:{
    handle:'bio-stack',
    name:'BioStack™',
    label:'Daily Foundation',
    subtitle:'5-Vector Daily Formula',
    desc:'A precision biological reset — formulated to move five vectors of human performance: cognitive clarity, stress resilience, cellular radiance, hepatic defence, and sustained vitality. Not a multivitamin — biomimetic dosing in forms your enzymes recognise.',
    pills:['Alpha GPC','L-Glutathione','Milk Thistle 80%','Ashwagandha 5%','Liposomal Vit C','Sea Buckthorn'],
    imgs:[
      'https://justwhatworks.in/cdn/shop/files/biostack-9807974.png?v=1777298710&width=600',
      'https://justwhatworks.in/cdn/shop/files/biostack-5139912.png?v=1777298711&width=600',
      'https://justwhatworks.in/cdn/shop/files/biostack-8951822.png?v=1777298711&width=600',
      'https://justwhatworks.in/cdn/shop/files/biostack-5848260.webp?v=1777298710&width=600'
    ],
    url:'/products/bio-stack',
    price:'₹699', og:'₹999', each:'₹23.30',
    color:'#f16023'
  },
  zerodrift:{
    handle:'zerodrift',
    name:'ZeroDrift™',
    label:'Cognitive Precision',
    subtitle:'Caffeine-Free Neural Performance',
    desc:'Next-generation neural performance formula that creates deep focus and sustained mental output without caffeine crashes. Enhances neurovascular coupling — directing oxygen and nutrients precisely to active neurons for smooth flow-state transitions.',
    pills:['Mangifera Indica','Alpha GPC 50%','L-Theanine 99%','Theobromine','Methylated B12','P5P (Active B6)'],
    imgs:[
      'https://justwhatworks.in/cdn/shop/files/zerodrift-8590605.png?v=1777298712&width=600',
      'https://justwhatworks.in/cdn/shop/files/zerodrift-2908779.png?v=1777298711&width=600',
      'https://justwhatworks.in/cdn/shop/files/zerodrift-4449715.png?v=1777298712&width=600',
      'https://justwhatworks.in/cdn/shop/files/zerodrift-9242754.webp?v=1777298712&width=600'
    ],
    url:'/products/zerodrift',
    price:'₹1,299', og:'₹1,499', each:'₹43.30',
    color:'#3c54a4'
  },
  sleep:{
    handle:'sleep-reset',
    name:'Sleep Reset™',
    label:'Deep Restoration',
    subtitle:'Anti-Glycation + Neuroadaptive Sleep',
    desc:'Melatonin-free, non-habit forming sleep formula. Targets glycation damage during sleep, modulates cortisol at the HPA axis, and supports full REM architecture — so you wake genuinely restored, not just rested.',
    pills:['Sensoril® Ashwagandha','L-Glycine 99%','NAC','Apigenin','Chamomile Extract','Active B6 (P5P)'],
    imgs:[
      'https://cdn.shopify.com/s/files/1/0998/5353/3506/files/sleep-reset-4395663.png?v=1777298711&width=600',
      'https://cdn.shopify.com/s/files/1/0998/5353/3506/files/sleep-reset-9901078.png?v=1777298711&width=600',
      'https://cdn.shopify.com/s/files/1/0998/5353/3506/files/sleep-reset-9959455.png?v=1777298712&width=600',
      'https://cdn.shopify.com/s/files/1/0998/5353/3506/files/sleep-reset-5960228.webp?v=1777298711&width=600'
    ],
    url:'/products/sleep-reset',
    price:'₹1,299', og:'₹1,499', each:'₹43.30',
    color:'#4c8990'
  },
  mag:{
    handle:'mag-elevate',
    name:'MagElevate™',
    label:'Neuro-Cellular Reset',
    subtitle:'Precision Neuro-Magnesium Complex',
    desc:'Solves the "tired mind, wired body" paradox. Combines five advanced magnesium forms with spermidine — crosses the blood-brain barrier to calm neural firing, promote deep sleep architecture, and trigger cellular autophagy.',
    pills:['Magtein® (Mg Threonate)','Aquamin® Marine Mg','Liposomal Glutathione','Spermidine','PSP (B6 Active)','Vitamin D3'],
    imgs:[
      'https://justwhatworks.in/cdn/shop/files/magelevate-1085842.png?v=1777298714&width=600',
      'https://justwhatworks.in/cdn/shop/files/magelevate-7094776.png?v=1777298711&width=600',
      'https://justwhatworks.in/cdn/shop/files/magelevate-1812295.png?v=1777298712&width=600',
      'https://justwhatworks.in/cdn/shop/files/magelevate-5127779.webp?v=1777298710&width=600'
    ],
    url:'/products/mag-elevate',
    price:'₹1,299', og:'₹1,499', each:'₹21.65',
    color:'#6a6a95'
  },
  liver:{
    handle:'liver-detox',
    name:'Liver Detox™',
    label:'Metabolic Defense',
    subtitle:'Advanced Liver Cleanse + Cellular Defense',
    desc:'Activates Phase I & II hepatic detox pathways simultaneously. Fermented Black Garlic provides S-allyl-cysteine — the most bioavailable form. Supports alcohol metabolism, antioxidant defence, and cellular regeneration.',
    pills:['Fermented Black Garlic','Milk Thistle 80%','NAC','Berberine HCl','Active B-Vitamins','Silymarin Complex'],
    imgs:[
      'https://justwhatworks.in/cdn/shop/files/p2.png?v=1774425628&width=600',
      'https://justwhatworks.in/cdn/shop/files/p2.png?v=1774425628&width=600'
    ],
    url:'/products/liver-detox',
    price:'₹1,499', og:'₹1,699', each:'₹24.98',
    color:'#2a7b6b'
  }
};

/* ─── Protocol engine ─────────── */
const PROTOCOLS = {
  Focus:{ title:'The Cognitive Flow Protocol', products:['biostack','zerodrift'],
    note:'<strong>Why this stack:</strong> BioStack™ supplies Alpha GPC, L-Theanine, and methylated B-vitamins — the neural substrates and mitochondrial fuel your brain needs daily. ZeroDrift™ adds distraction-free cognitive output via Mangifera + Theobromine without cortisol-spiking caffeine.' },
  Calm:{ title:'The Cortisol Defense Protocol', products:['biostack','mag'],
    note:'<strong>Why this stack:</strong> BioStack™ delivers Ashwagandha (5% Withanolides) for HPA-axis regulation. MagElevate™ adds Magtein® — the only magnesium clinically shown to cross the blood-brain barrier — directly down-regulating neurological over-arousal.' },
  Sleep:{ title:'The Deep Restoration Protocol', products:['sleep','mag'],
    note:'<strong>Why this stack:</strong> Sleep Reset™ combines Sensoril® Ashwagandha, L-Glycine, and NAC for multi-pathway sleep repair and overnight anti-glycation defense — completely melatonin-free. MagElevate™ adds the cellular reset layer for genuine morning clarity.' },
  Detox:{ title:'The Metabolic Reset Protocol', products:['liver','biostack'],
    note:'<strong>Why this stack:</strong> Liver Detox™ activates Phase I & II hepatic pathways with Berberine, Milk Thistle (80% Silymarin), and Fermented Black Garlic — rich in S-allyl-cysteine. BioStack™ supports the cellular regeneration required after deep detox.' }
};

/* ─── Google Sheet ─────────── */
const SHEET_URL = 'https://script.google.com/macros/s/AKfycbyGPQfbKF3_QOqoiTDTO3OVQuNoLWi3_5vXtr76kD094vuwsivp-lw6Qv_HaVVdU1hZ/exec';

async function saveLead(lead) {
  try {
    await fetch(SHEET_URL, {
      method:'POST', mode:'no-cors',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify(lead)
    });
  } catch(e) { /* fail silently */ }
}

/* ─── Full-page signal waveform animation ────────────────────────
   Mounted on .wrap (entire page background).
   Layered biosignal traces (ECG / EEG feel) scrolling gently — the
   orange line carries a subtle heartbeat spike + a moving readout dot.
   Clinical, calm, on-message for "we read your physiology."
   Brand colors: orange #F15F22, gold #867353, teal #205C66
   Mobile: same lines, lighter shadow blur for perf.
   Pauses when tab hidden.
─────────────────────────────────────────────────────────────────── */
(function initWaveform() {
  const wrap = document.getElementById('jww-finder');
  if (!wrap) return;

  const cv = document.createElement('canvas');
  cv.id = 'jww-bubble-canvas';
  cv.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:1;';
  wrap.insertBefore(cv, wrap.firstChild);

  const ctx = cv.getContext('2d');
  let t = 0, raf, isMobile = false;

  // Layered biosignal traces. yf = vertical anchor (fraction of height).
  // amp = wave height, freq = cycles across width, sp = scroll speed,
  // w = line width, a = base alpha, c = brand RGB.
  const LINES = [
    { c:'241,95,34',  amp:0.05, freq:2.2, sp:0.7, yf:0.30, w:1.6, a:0.32 }, // orange — carries heartbeat
    { c:'32,92,102',  amp:0.06, freq:1.6, sp:0.5, yf:0.50, w:1.4, a:0.26 }, // teal
    { c:'134,115,83', amp:0.04, freq:3.0, sp:0.9, yf:0.68, w:1.2, a:0.24 }, // gold
  ];

  function resize() {
    cv.width  = wrap.offsetWidth;
    cv.height = wrap.offsetHeight;
    isMobile  = window.innerWidth <= 480;
  }

  function draw() {
    t += 0.006;
    const W = cv.width, H = cv.height;
    ctx.clearRect(0, 0, W, H);

    LINES.forEach((L, idx) => {
      ctx.beginPath();
      for (let x = 0; x <= W; x += 6) {
        const ph = (x / W) * Math.PI * 2 * L.freq + t * L.sp;
        let y = Math.sin(ph) * H * L.amp;

        // Orange line gets an occasional sharper "beat" spike
        if (idx === 0) {
          const beat = Math.sin((x / W) * Math.PI * 2 * 8 + t * 2);
          if (beat > 0.96) y -= H * 0.08 * (beat - 0.96) / 0.04;
        }
        y += Math.sin(ph * 2.3) * H * L.amp * 0.3; // subtle texture

        const yy = L.yf * H + y;
        x === 0 ? ctx.moveTo(x, yy) : ctx.lineTo(x, yy);
      }
      ctx.strokeStyle = `rgba(${L.c},${L.a})`;
      ctx.lineWidth   = L.w;
      ctx.shadowColor = `rgba(${L.c},0.4)`;
      ctx.shadowBlur  = isMobile ? 4 : 8;
      ctx.stroke();
      ctx.shadowBlur  = 0;

      // Moving readout dot riding the orange line
      if (idx === 0) {
        const px = (t * L.sp * W / (Math.PI * 2 * L.freq) * Math.PI * 2) % W;
        const ph = (px / W) * Math.PI * 2 * L.freq + t * L.sp;
        const py = L.yf * H + Math.sin(ph) * H * L.amp;
        ctx.beginPath();
        ctx.arc(px, py, 4, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(${L.c},0.9)`;
        ctx.fill();
      }
    });

    raf = requestAnimationFrame(draw);
  }

  const ro = new ResizeObserver(() => resize());
  ro.observe(wrap);
  resize();
  draw();

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) cancelAnimationFrame(raf);
    else { raf = requestAnimationFrame(draw); }
  });
})();

/* ─── Dot progress tracker ───────────────────────────────────────
   Inserts a row of 8 dots below the progress bar.
   Called by go() on every step change.
─────────────────────────────────────────────────────────────────── */
(function initDots() {
  const track = document.querySelector('.prog-track');
  if (!track) return;
  const row = document.createElement('div');
  row.className = 'prog-dots';
  row.id = 'jww-prog-dots';
  track.after(row);
})();

function updateDots(n) {
  const row = document.getElementById('jww-prog-dots');
  if (!row) return;
  const stepNum = typeof n === 'number' ? n : (n === 'result' ? TOTAL + 1 : null);
  row.innerHTML = '';
  for (let i = 1; i <= TOTAL; i++) {
    const d = document.createElement('span');
    d.className = 'pdot' +
      (stepNum === null ? '' :
       i < stepNum  ? ' done' :
       i === stepNum ? ' active' : '');
    row.appendChild(d);
  }
}

/* ─── Stagger option cards ───────────────────────────────────────
   After each step becomes active, assign --i CSS custom property
   to each .opt so the CSS animation-delay staggers them in.
─────────────────────────────────────────────────────────────────── */
function staggerOptions(stepEl) {
  if (!stepEl) return;
  const opts = stepEl.querySelectorAll('.opt');
  opts.forEach((opt, i) => {
    // Reset animation so it re-fires on every step entry
    opt.style.animation = 'none';
    opt.style.setProperty('--i', i);
    // Force reflow then re-enable animation
    void opt.offsetWidth;
    opt.style.animation = '';
  });
}

/* ─── Navigation ─────────────────────────────────────────────────
   Adds direction awareness: forward slides right-to-left,
   back slides left-to-right.
─────────────────────────────────────────────────────────────────── */
let _lastStep = 1;

function go(n, isBack) {
  requestAnimationFrame(() => {
    document.querySelectorAll('.step').forEach(s => {
      s.classList.remove('active', 'going-back');
    });

    const next = document.getElementById('step-' + n);
    if (next) {
      if (isBack) next.classList.add('going-back');
      next.classList.add('active');
      staggerOptions(next);
    }

    const pct = typeof n === 'number' ? (n / TOTAL * 100) : 100;
    document.getElementById('prog').style.width = Math.min(pct, 100) + '%';

    updateDots(n);
    _lastStep = n;

    const finder = document.getElementById('jww-finder');
    if (finder) {
      const rect = finder.getBoundingClientRect();
      if (rect.top < -5 || rect.top > 60) {
        finder.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  });
}

function goBack(n) { go(n, true); }

function setGoal(g, n) { S.goal = g; go(n); }
function rec(k, v) { S.answers[k] = v; }

/* ─── Auto-advance with flash ────────────────────────────────────
   Wraps the inline onclick calls. Flashes the selected option
   orange for 300ms, then advances to the next step.
   Usage in HTML: onclick="pick(this, function(){ rec('key','val'); go(N) })"
   — but to stay compatible with existing HTML we expose a helper
   that wraps any go() / setGoal() call.
─────────────────────────────────────────────────────────────────── */
function pickAndGo(btnEl, fn) {
  // Prevent double-tap
  if (btnEl.classList.contains('opt-selected')) return;
  // Disable all opts in this step briefly
  const step = btnEl.closest('.step');
  if (step) step.querySelectorAll('.opt').forEach(o => o.style.pointerEvents = 'none');

  btnEl.classList.add('opt-selected');
  setTimeout(() => {
    if (step) step.querySelectorAll('.opt').forEach(o => o.style.pointerEvents = '');
    fn();
  }, 300);
}

/* ─── Gate validation ─────────────────────────────────────────── */
function submitGate() {
  const name   = document.getElementById('f-name').value.trim();
  const phone  = document.getElementById('f-phone').value.trim().replace(/\s+/g,'');
  const email  = document.getElementById('f-email').value.trim();
  const age    = document.getElementById('f-age').value.trim();
  const gender = document.getElementById('f-gender').value;
  let ok = true;

  const check = (id, eid, cond) => {
    const el = document.getElementById(id), er = document.getElementById(eid);
    if (!cond) { el.classList.add('err'); er.classList.add('show'); ok = false; }
    else        { el.classList.remove('err'); er.classList.remove('show'); }
  };

  check('f-name',   'e-name',   name.length >= 2);

  const phoneDigits = phone.replace(/^\+91/, '').replace(/\D/g, '');
  if (phone.length > 0) {
    check('f-phone', 'e-phone', phoneDigits.length >= 10);
  } else {
    document.getElementById('f-phone').classList.remove('err');
    document.getElementById('e-phone').classList.remove('show');
  }

  check('f-email',  'e-email',  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email));
  check('f-age',    'e-age',    age !== '' && Number(age) >= 10 && Number(age) <= 100);
  check('f-gender', 'e-gender', gender !== '');

  if (!ok) return;

  S.lead = {
    name,
    phone: phoneDigits,
    email, age, gender,
    ts: Date.now(),
    date: new Date().toLocaleString('en-IN', { timeZone:'Asia/Kolkata', dateStyle:'medium', timeStyle:'short' })
  };
  startLoading();
}

/* Live clear errors */
['f-name','f-phone','f-email','f-age','f-gender'].forEach(id => {
  const el = document.getElementById(id);
  if (!el) return;
  const clear = function() {
    this.classList.remove('err');
    this.parentElement.querySelector('.ferr')?.classList.remove('show');
  };
  el.addEventListener('input',  clear);
  el.addEventListener('change', clear);
});

/* ─── Fetch variant ID ─────────────────────────────────────────── */
async function getVid(handle) {
  if (S.variants[handle]) return S.variants[handle];
  try {
    const r = await fetch(`/products/${handle}.js`);
    if (!r.ok) throw 0;
    const d = await r.json();
    const id = d.variants?.[0]?.id;
    if (id) S.variants[handle] = id;
    return id;
  } catch { return null; }
}

/* ─── Shopify cart ─────────────────────────────────────────────── */
async function shopifyCart(items) {
  const drawer = document.querySelector('cart-drawer');
  const fd = new FormData();
  items.forEach((it, i) => {
    fd.append(`items[${i}][id]`, it.id);
    fd.append(`items[${i}][quantity]`, it.qty || 1);
  });
  const secs = drawer?.getSectionsToRender?.()?.map(s => s.id) || ['cart-drawer','cart-icon-bubble'];
  fd.append('sections', secs.join(','));
  fd.append('sections_url', window.location.pathname);
  const res = await fetch(window.Shopify?.routes?.cart_add_url || '/cart/add.js', {
    method:'POST',
    headers:{ 'X-Requested-With':'XMLHttpRequest', Accept:'application/javascript' },
    body:fd
  });
  if (!res.ok) throw new Error(res.status);
  const json = await res.json();
  if (drawer?.renderContents) drawer.renderContents(json, true);
  else {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined')
      publish(PUB_SUB_EVENTS.cartUpdate, { source:'stack-finder', cartData:json });
    document.querySelector('.wt-cart__trigger')?.click();
  }
  return json;
}

async function shopifyRemove(handle) {
  const vid = S.variants[handle];
  if (!vid) return;
  const res = await fetch('/cart/change.js', {
    method:'POST',
    headers:{ 'Content-Type':'application/json' },
    body:JSON.stringify({ id:vid, quantity:0 })
  });
  if (!res.ok) throw new Error(res.status);
  return res.json();
}

/* ─── Product card builder ─────────────────────────────────────── */
function buildCard(key, isA) {
  const p = PRODS[key];
  const card = document.createElement('div');
  card.className = 'pcard';
  card.id = `pcard-${key}`;

  const acc = document.createElement('div');
  acc.className = 'pcard-accent';
  acc.style.background = p.color;

  const slider = document.createElement('div');
  slider.className = 'pcard-slider';
  const slides = document.createElement('div');
  slides.className = 'pcard-slides';
  slides.id = `slides-${key}`;

  p.imgs.forEach((src, i) => {
    const slide = document.createElement('div');
    slide.className = 'pcard-slide';
    const img = document.createElement('img');
    img.src = src;
    img.alt = `${p.name} image ${i + 1}`;
    img.loading = i === 0 ? 'eager' : 'lazy';
    img.onerror = function() {
      this.closest('.pcard-slide').style.display = 'none';
      const dots = document.querySelectorAll(`#pcard-${key} .dot`);
      if (dots[i]) dots[i].style.display = 'none';
    };
    slide.appendChild(img);
    slides.appendChild(slide);
  });

  const dotsEl = document.createElement('div');
  dotsEl.className = 'pcard-dots';
  p.imgs.forEach((_, i) => {
    const d = document.createElement('div');
    d.className = 'dot' + (i === 0 ? ' active' : '');
    d.style.background = i === 0 ? p.color : '';
    d.onclick = () => slideTo(key, i);
    dotsEl.appendChild(d);
  });

  const arL = document.createElement('div');
  arL.className = 'sarrow sarrow-l'; arL.textContent = '‹';
  arL.onclick = () => slideStep(key, -1);
  const arR = document.createElement('div');
  arR.className = 'sarrow sarrow-r'; arR.textContent = '›';
  arR.onclick = () => slideStep(key, 1);

  let tx = 0;
  slides.addEventListener('touchstart', e => { tx = e.touches[0].clientX; }, { passive:true });
  slides.addEventListener('touchend',   e => {
    const dx = e.changedTouches[0].clientX - tx;
    if (Math.abs(dx) > 40) slideStep(key, dx < 0 ? 1 : -1);
  }, { passive:true });

  slider.appendChild(slides);
  slider.appendChild(dotsEl);
  slider.appendChild(arL);
  slider.appendChild(arR);

  const body = document.createElement('div');
  body.className = 'pcard-body';
  body.innerHTML = `
    <div class="pcard-top">
      <div class="pcard-meta">
        <span class="pcard-label">${isA ? 'Daily Foundation' : p.label}</span>
        <span class="pcard-name">${p.name}</span>
        <span class="pcard-sub">${p.subtitle}</span>
      </div>
      <div class="pcard-price-wrap">
        <span class="pcard-og">${p.og}</span>
        <span class="pcard-price">${p.price}</span>
        <span class="pcard-each">${p.each} per capsule</span>
      </div>
    </div>
    <div class="pcard-pills">${p.pills.map(t => `<span class="pill" style="border-color:${p.color}22;color:${p.color}">${t}</span>`).join('')}</div>
    <div class="pcard-benefit">${p.desc}</div>
    <div class="pcard-actions">
      <div class="qty-ctrl" id="qty-${key}">
        <button class="qty-btn" onclick="changeQty('${key}',-1)">−</button>
        <span class="qty-num" id="qn-${key}">1</span>
        <button class="qty-btn" onclick="changeQty('${key}',1)">+</button>
      </div>
      <button class="atc-btn" id="atc-${key}" onclick="addSingle('${key}',this)">Add to Cart</button>
      <a class="view-link" href="${p.url}" target="_blank" rel="noopener">View <svg viewBox="0 0 24 24"><path d="M7 17L17 7M9 7h8v8"/></svg></a>
    </div>
  `;

  card.appendChild(acc);
  card.appendChild(slider);
  card.appendChild(body);
  return card;
}

/* ─── Slider ─────────────────────────────────────────────────── */
const SLIDE_IDX = {};
function slideTo(key, idx) {
  const p = PRODS[key];
  const max = p.imgs.length - 1;
  idx = Math.max(0, Math.min(idx, max));
  SLIDE_IDX[key] = idx;
  document.getElementById(`slides-${key}`).style.transform = `translateX(-${idx * 100}%)`;
  const dots = document.querySelectorAll(`#pcard-${key} .dot`);
  dots.forEach((d, i) => {
    d.classList.toggle('active', i === idx);
    d.style.background = i === idx ? p.color : '';
  });
}
function slideStep(key, dir) { slideTo(key, (SLIDE_IDX[key] || 0) + dir); }

/* ─── Cart: single ───────────────────────────────────────────── */
async function addSingle(key, btn) {
  btn.classList.add('adding'); btn.textContent = 'Adding…'; btn.disabled = true;
  const id = await getVid(PRODS[key].handle);
  if (!id) {
    btn.classList.remove('adding'); btn.textContent = 'Add to Cart'; btn.disabled = false;
    toast('Could not load product');
    return;
  }
  try {
    await shopifyCart([{ id, qty:1 }]);
    S.cartQty[key] = (S.cartQty[key] || 0) + 1;
    showQtyCtrl(key);
    btn.classList.remove('adding'); btn.classList.add('added'); btn.textContent = '✓ In Cart';
    toast(`${PRODS[key].name} added ✓`);
  } catch {
    btn.classList.remove('adding'); btn.textContent = 'Add to Cart'; btn.disabled = false;
    toast('Error — please try again');
  }
}

function showQtyCtrl(key) {
  const btn  = document.getElementById(`atc-${key}`);
  const ctrl = document.getElementById(`qty-${key}`);
  const qn   = document.getElementById(`qn-${key}`);
  qn.textContent = S.cartQty[key] || 1;
  ctrl.classList.add('visible');
  btn.style.display = 'none';
}

async function changeQty(key, delta) {
  const cur  = S.cartQty[key] || 1;
  const next = cur + delta;
  const ctrl = document.getElementById(`qty-${key}`);
  const btn  = document.getElementById(`atc-${key}`);
  const qn   = document.getElementById(`qn-${key}`);

  if (next <= 0) {
    try { await shopifyRemove(key); } catch {}
    S.cartQty[key] = 0;
    ctrl.classList.remove('visible');
    btn.style.display = ''; btn.classList.remove('added'); btn.disabled = false; btn.textContent = 'Add to Cart';
    toast(`${PRODS[key].name} removed`);
    return;
  }
  if (delta > 0) {
    const id = S.variants[PRODS[key].handle] || await getVid(PRODS[key].handle);
    if (id) { try { await shopifyCart([{ id, qty:1 }]); } catch {} }
  } else {
    const id = S.variants[PRODS[key].handle];
    if (id) {
      try { await fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ id, quantity:next }) }); } catch {}
    }
  }
  S.cartQty[key] = next;
  qn.textContent = next;
}

/* ─── Add all ───────────────────────────────────────────────── */
async function addAll() {
  const btn  = document.getElementById('btn-all');
  const goal = S.goal || 'Focus';
  const keys = PROTOCOLS[goal].products;
  btn.classList.add('st-adding'); btn.textContent = 'Adding to cart…'; btn.disabled = true;

  const ids   = await Promise.all(keys.map(k => getVid(PRODS[k].handle)));
  const items = ids.filter(Boolean).map(id => ({ id, qty:1 }));

  if (!items.length) {
    btn.classList.remove('st-adding'); btn.textContent = 'Add Full Protocol to Cart'; btn.disabled = false;
    toast('Could not load products — opening shop…');
    setTimeout(() => { window.location.href = '/collections'; }, 800);
    return;
  }
  try {
    await shopifyCart(items);
    keys.forEach((k, i) => { if (ids[i]) { S.cartQty[k] = (S.cartQty[k] || 0) + 1; showQtyCtrl(k); } });
    btn.classList.remove('st-adding'); btn.classList.add('st-done'); btn.textContent = `✓ ${items.length} Products Added`;
    toast('Full protocol added to cart ✓');
    setTimeout(() => {
      btn.classList.remove('st-done'); btn.textContent = 'Go to Cart →'; btn.disabled = false;
      btn.onclick = () => { window.location.href = '/cart'; };
    }, 3000);
  } catch {
    btn.classList.remove('st-adding'); btn.textContent = 'Add Full Protocol to Cart'; btn.disabled = false;
    toast('Error adding to cart');
  }
}

/* ─── Analyse → gate ─────────────────────────────────────────── */
function analyse() { go('gate'); }

/* ─── Loading ────────────────────────────────────────────────── */
function startLoading() {
  document.querySelectorAll('.lb').forEach(b => b.classList.remove('done'));
  go('loading');
  const bars = document.querySelectorAll('.lb');
  let i = 0;
  const iv = setInterval(() => {
    if (i < bars.length) { bars[i].classList.add('done'); i++; }
    else { clearInterval(iv); setTimeout(renderResult, 320); }
  }, 260);
}

/* ─── Render result ──────────────────────────────────────────── */
async function renderResult() {
  const goal  = S.goal || 'Focus';
  const proto = PROTOCOLS[goal];
  document.getElementById('r-title').textContent = proto.title;
  document.getElementById('r-goal').textContent  = goal;
  document.getElementById('r-note').innerHTML    = proto.note;

  proto.products.forEach(k => getVid(PRODS[k].handle));

  const container = document.getElementById('r-cards');
  container.innerHTML = '';
  proto.products.forEach((key, idx) => {
    container.appendChild(buildCard(key, idx === 0));
    SLIDE_IDX[key] = 0;
  });

  if (S.lead) {
    S.lead.protocol     = proto.title;
    S.lead.protocolGoal = goal;
    S.lead.products     = proto.products.map(k => PRODS[k].name).join(' + ');
    saveLead(S.lead);
  }

  const btn = document.getElementById('btn-all');
  btn.textContent = 'Add Full Protocol to Cart';
  btn.className   = 'bcta';
  btn.disabled    = false;
  btn.onclick     = addAll;

  go('result');
}

/* ─── Toast ──────────────────────────────────────────────────── */
function toast(msg) {
  const el = document.getElementById('toast');
  el.textContent = msg;
  el.classList.add('show');
  setTimeout(() => el.classList.remove('show'), 3000);
}

/* ─── Reset ──────────────────────────────────────────────────── */
function resetQuiz() {
  S.goal = null; S.answers = {}; S.lead = null; S.cartQty = {};
  ['f-name','f-phone','f-email','f-age','f-gender'].forEach(id => {
    const el = document.getElementById(id);
    if (el) { el.value = ''; el.classList.remove('err'); }
  });
  ['e-name','e-phone','e-email','e-age','e-gender'].forEach(id => {
    document.getElementById(id)?.classList.remove('show');
  });
  document.querySelectorAll('.lb').forEach(b => b.classList.remove('done'));
  go(1);
}

/* ─── Init: stagger first step options on page load ─────────── */
requestAnimationFrame(() => {
  const first = document.querySelector('.step.active');
  if (first) staggerOptions(first);
  updateDots(1);
});